import { dataBoxSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBoxSolid = /*#__PURE__*/createIcon(dataBoxSolid)
export default IconBoxSolid
